import { Component, Input, OnInit } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { CallToActionComponentContext } from './call-to-action-context.interface';

@Component({
    selector: 'app-call-to-action',
    templateUrl: './call-to-action.component.html',
    styleUrls: ['./call-to-action.component.min.css'],
})
export class CallToActionComponent implements BuildingBlockInterface, OnInit {
    @Input() public context: CallToActionComponentContext;
    public paddingEnabled = false;

    public ngOnInit(): void {
        if (this.context.href && this.context.innerLink) {
            throw new Error('Can\'t use both href and innerLink.');
        }
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/call-to-action/call-to-action.component.ts